import React from 'react';
import { FaCloud, FaDatabase, FaNetworkWired } from 'react-icons/fa';
import useScrollAnimation from '../hooks/useScrollAnimation';
import '../styles/aas.css';

const aasData = {
  title: 'AAS',
  overview:
    'Asset Administration Shell 기반 산업용 IoT 데이터 관리 시스템입니다. 다양한 센서 데이터를 표준화된 AASX 형식으로 변환하고 효율적으로 관리하여, 스마트 팩토리 구축을 위한 핵심 인프라를 제공합니다.',
  images: {
    main: '/images/aas-dashboard.jpg',
    weight: '/images/weight.jpg',
  },
  features: [
    {
      title: '기초 코드 관리',
      items: ['센서 선택 및 저장', '데이터 구조 정의', '별칭 관리 시스템'],
    },
    {
      title: 'AASX 파일 생성',
      items: ['표준화된 파일 포맷', 'JSON to AASX 변환', '트리 구조 관리'],
    },
    {
      title: '데이터 변환 시스템',
      items: ['날짜 범위 선택', 'JSON 파일 생성', '센서 데이터 통합'],
    },
    {
      title: 'Edge Gateway 관리',
      items: ['서버 연동', '원격 제어', '데이터 송수신'],
    },
    {
      title: '실시간 모니터링',
      items: ['센서 데이터 추적', '공장 설비 관리', '데이터 분석'],
    },
    {
      title: '파일 관리',
      items: ['JSON/AAS/AASX 파일 통합 관리', '버전 관리', '백업 시스템'],
    },
  ],
  technology: [
    {
      icon: <FaCloud size={24} />,
      title: '클라우드 관제',
      items: ['실시간 데이터 처리', '통합 디바이스 관리', '웹 기반 관리 시스템'],
    },
    {
      icon: <FaDatabase size={24} />,
      title: '데이터베이스',
      items: ['MySQL 기반 데이터 저장', '센서 정보 관리', '파일 메타데이터 관리'],
    },
    {
      icon: <FaNetworkWired size={24} />,
      title: '시스템 연동',
      items: ['Backend (Node.js)', 'Frontend (React)', 'Python 데이터 처리'],
    },
  ],
  workflow: [
    {
      step: '기초 코드',
      description: 'AASX 파일로 만들 센서들을 선택하여 저장',
    },
    {
      step: 'DATA 변환',
      description: '기초 코드에서 선택한 센서들로 날짜 범위를 선택하여 JSON 파일 생성',
    },
    {
      step: '데이터 관리',
      description: '생성된 JSON 파일을 선택하여 AAS(AASX JSON) 파일 생성',
    },
    {
      step: 'AASX 관리',
      description: '데이터 관리에서 생성된 파일을 선택하여 최종 AASX 파일 생성',
    },
    {
      step: 'DATA 송신',
      description: 'AASX 파일을 트리 구조로 확인 및 데이터 전송',
    },
    {
      step: 'Edge Gateway 관리',
      description: '서버 연동 및 실시간 데이터 송수신',
    },
  ],
};

const AASSystem = () => {
  useScrollAnimation();

  return (
    <section className="aas-section">
      <div className="aas-container">
        <h3 className="aas-modal-title">{aasData.title}</h3>
        <div className="aas-modal-image">
          <img src={aasData.images.main} alt={aasData.title} />
        </div>

        <div className="aas-modal-section">
          <h4 className="aas-modal-section-title">시스템 개요</h4>
          <p className="aas-modal-description">{aasData.overview}</p>
        </div>

        <div className="aas-flow-section">
          <h4 className="aas-modal-section-title">시스템 워크플로우</h4>
          <ol className="aas-flow-list">
            {aasData.workflow.map((item, index) => (
              <li key={index}>
                <strong>{item.step}</strong>
                {item.description}
              </li>
            ))}
          </ol>
        </div>

        <div className="aas-modal-section">
          <h4 className="aas-modal-section-title">주요 기능</h4>
          <div className="aas-feature-grid">
            {aasData.features.map((feature, index) => (
              <div key={index} className="aas-feature-card">
                <h5>{feature.title}</h5>
                <ul>
                  {feature.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="aas-modal-section">
          <h4 className="aas-modal-section-title">기술 스택</h4>
          <div className="aas-feature-grid">
            {aasData.technology.map((tech, index) => (
              <div key={index} className="aas-feature-card">
                <div className="aas-tech-icon">{tech.icon}</div>
                <h5>{tech.title}</h5>
                <ul>
                  {tech.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AASSystem;
